/**
 * 运营首页 API（operations-dashboard:ADM-01）。
 *
 * - GET /operations/dashboard -> 九类指标 + 今日课次列表 + 待办摘要
 *   （query: campusId/statDate；部分段失败时对应计数为 null 且 sectionErrors 登记）
 */
import { ApiPaths } from './api.config';
import { http } from './transport';

/** 今日课次行。 */
export interface DashboardTodaySession {
  sessionId: string;
  startAt: string;
  className: string;
  teacherName: string;
  classroomName: string;
  studentCount: number;
  status: string;
  classroomChanged: boolean;
}

/** 待办摘要项（仅类型 + 数量，无跳转 URL）。 */
export interface DashboardTodoItem {
  type: 'PENDING_DEDUCTION' | 'DEDUCTION_EXCEPTION' | 'FUND_EXCEPTION' | 'OVERDUE_FINAL';
  count: number | null;
}

/** 运营首页读模型（失败段为 null）。 */
export interface OperationsDashboard {
  campusId: string | null;
  statDate: string;
  enrollmentCount: number | null;
  trialingCount: number | null;
  paidOrderCount: number | null;
  pendingPlacementCount: number | null;
  inClassCount: number | null;
  pendingDepositCount: number | null;
  pendingFullCount: number | null;
  pendingFinalCount: number | null;
  overdueFinalCount: number | null;
  undeterminedCount: number | null;
  todaySessionCount: number | null;
  todaySessions: DashboardTodaySession[] | null;
  pendingDeductionCount: number | null;
  deductionExceptionCount: number | null;
  fundExceptionCount: number | null;
  todos: DashboardTodoItem[];
  sectionErrors?: string[];
}

/** 运营首页查询参数。 */
export interface OperationsDashboardQuery {
  campusId?: string;
  statDate?: string;
}

/** 待办类型中文标签。 */
export const DASHBOARD_TODO_LABEL: Record<DashboardTodoItem['type'], string> = {
  PENDING_DEDUCTION: '待消课课次',
  DEDUCTION_EXCEPTION: '消课异常待处理',
  FUND_EXCEPTION: '资金异常待处理',
  OVERDUE_FINAL: '尾款逾期',
};

async function getOperationsDashboard(
  query: OperationsDashboardQuery = {},
): Promise<OperationsDashboard> {
  const params = new URLSearchParams();
  if (query.campusId) params.set('campusId', query.campusId);
  if (query.statDate) params.set('statDate', query.statDate);
  const qs = params.toString();
  const path = qs
    ? `${ApiPaths.operationsDashboard.summary}?${qs}`
    : ApiPaths.operationsDashboard.summary;
  return http.get<OperationsDashboard>(path);
}

/** 运营首页 API 唯一对外入口。 */
export const operationsApi = {
  getOperationsDashboard,
};
